import React from 'react';
import { DmpLogo } from '../brand/DmpLogo';
import { BdFlag } from '../brand/BdFlag';
export function DocHeader({
  office,
  title
}: {
  office: string;
  title: string;
}) {
  return <div className="border-b-2 border-navy pb-3 mb-4" data-id="element-207" data-mp="2si3ikgtkywv2">
      <div className="flex items-start justify-between gap-3" data-id="element-208" data-mp="2sjej87rqbohy">
        <DmpLogo size={52} data-id="element-209" data-mp="2winghmlza4i9" />
        <div className="text-center flex-1" data-id="element-210" data-mp="2wjyhjeo1gy5o">
          <p className="text-[11px] text-ink-muted" data-id="element-211" data-mp="3k99bac6z1sab">গণপ্রজাতন্ত্রী বাংলাদেশ সরকার</p>
          <p className="text-lg font-bold text-navy leading-tight" data-id="element-212" data-mp="3k76py5grknbx">ঢাকা মেট্রোপলিটন পুলিশ</p>
          <p className="text-xs text-ink" data-id="element-213" data-mp="3p5qb43nj9v38">{office}</p>
        </div>
        <BdFlag width={36} data-id="element-214" data-mp="3b7jnrhg7ndht" />
      </div>
      <p className="mt-3 text-center text-base font-bold text-ink underline underline-offset-4" data-id="element-215" data-mp="3banzczw09bii">{title}</p>
    </div>;
}
export function KV({
  k,
  v,
  mono = false
}: {
  k: string;
  v: React.ReactNode;
  mono?: boolean;
}) {
  return <div className="flex gap-2 py-1 border-b border-dotted border-line text-[13px]" data-id="element-216" data-mp="24siz7wtilxl9">
      <span className="w-36 shrink-0 text-ink-muted" data-id="element-217" data-mp="2jvk3a6t4cy0a">{k}</span>
      <span className={`font-semibold text-ink ${mono ? 'font-mono' : ''}`} data-id="element-218" data-mp="2jxwg65k0si6h">{v}</span>
    </div>;
}